export default "__VITE_ASSET__BHzcPg6v__"